export enum CookieNames {
  ExternalEmployees = "HistoryLocationExternalEmployees",
  Companies = "HistoryLocationCompanies",
  Users = "HistoryLocationUsers",
  AccessRoles = "HistoryLocationAccessRoles",
  InvoiceItemCategories = "HistoryLocationInvoiceItemCategories",
}
